import { connect } from 'react-redux'
import { hacks } from '../../../utils'
import { propertySearchEvents, propertySearchSelectors } from '../../../modules/ui/PropertySearch'
import { propertyApiEvents, propertyApiSelectors } from '../../../modules/api/property'
import { propertyDetailsEvents } from 'modules/ui/ChatBot'
import { Search } from '../../components'
import debounce from 'lodash-es/debounce'
import { $TSFixMe } from 'types/ts-migrate'
import { apiStateSelectors } from 'modules/api/apiState'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapStateToProps = (state: any, { value = '', isReadonly }: $TSFixMe) => {
  const isLoading = apiStateSelectors.isLoading(state)([propertyApiEvents.search_request])
  const isAlternativeLoading = apiStateSelectors.isLoading(state)([propertyApiEvents.combinedSearch_request])
  const name = hacks.generateNameToFoolChromeAutofill('propertySearch-')
  const searchTerm = propertySearchSelectors.getCurrentSearchQuery(state)
  const alternativeResults = propertyApiSelectors.getCombinedSearchResultsByQuery(state)(searchTerm)
  const hasSearchedAlternative = propertyApiSelectors.hasCombinedSearchResultsForQuery(state)(searchTerm)
  const sortedResults = propertyApiSelectors.getSearchResultsSortedByMainTextUnitNumber(state)(searchTerm)

  // Split into labelled groups: properties already in the portfolio (have an id) vs deeds office matches.
  const ownedResults = sortedResults.filter((r: $TSFixMe) => r.id)
  const deedsOfficeResults = sortedResults.filter((r: $TSFixMe) => !r.id)
  const resultGroups = [
    ...(ownedResults.length ? [{ heading: 'Your properties', results: ownedResults }] : []),
    ...(deedsOfficeResults.length ? [{ heading: 'Deeds office', results: deedsOfficeResults }] : []),
  ]

  const placeholder = ''
  const label = 'Search for a property'
  const labelHint =
    "Search by the owner's ID number for the most accurate results, building name if the property is part of a building/complex, or street address"

  return {
    isLoading,
    isAlternativeLoading,
    hasSearchedAlternative,
    name,
    resultGroups,
    alternativeResultSets: [alternativeResults],
    placeholder,
    label,
    labelHint,
    value,
    disabled: isReadonly,
    showAlternativeSearchTrigger: true,
    showExistingPropertyTags: true,
    showTertiaryText: true,
  }
}

const debouncedPropertySearch = debounce((dispatch: any, value: any) => {
  dispatch(propertySearchEvents.propertySearchQuery(value))
}, 500)

const debouncedCombinedPropertySearch = debounce((dispatch: any, value: any) => {
  dispatch(propertySearchEvents.propertyCombinedSearchQuery(value))
}, 1000)

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapDispatchToProps = (dispatch, { onChange = () => {}, onResultSelect, value }: any) => ({
  value,

  onSearchChange: (e: any) => {
    onChange(e)
    debouncedPropertySearch(dispatch, e.target.value)
  },

  onAlternativeSearchClick: (value: any) => {
    debouncedCombinedPropertySearch(dispatch, value)
  },

  onResultSelect: (e: any, { result }: any) => {
    if (typeof onResultSelect === 'function') {
      onResultSelect(result)
    } else {
      const { id, placeId, lightstoneId } = result

      if (id !== undefined) {
        dispatch(propertyApiEvents.property_request({ id }))
        dispatch(propertyDetailsEvents.propertySelected({ id }))
      } else if (lightstoneId) {
        dispatch(propertyApiEvents.lightstoneProperty_request({ lightstoneId }))
        dispatch(propertyDetailsEvents.lightstonePropertySelected({ lightstoneId }))
      } else if (placeId !== undefined) {
        dispatch(propertyApiEvents.place_request({ placeId }))
        dispatch(propertyDetailsEvents.googlePlaceSelected({ placeId }))
      }
    }
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(Search)
